'use client'

import { useMemo } from 'react'

import dayjs from 'dayjs'
import 'dayjs/locale/uk'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import toObject from 'dayjs/plugin/toObject'
import updateLocale from 'dayjs/plugin/updateLocale'

import useLocale from './useLocale'

export default function useDateTime(): typeof dayjs {
  const locale = useLocale()

  return useMemo(() => {
    dayjs.extend(relativeTime)
    dayjs.extend(updateLocale)
    dayjs.extend(toObject)
    dayjs.extend(localizedFormat)
    dayjs.locale(locale)

    dayjs.updateLocale('uk', {
      formats: {
        L: 'DD/MM/YYYY', // Default separator in UK is a dot (DD.MM.YYYY)
      },
    })

    dayjs.updateLocale(locale as string, {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
      },
    })
    return dayjs
  }, [locale])
}
